export default "__VITE_ASSET__B0K8wn7L__"